export const TermsAndConditionsContest =
  {
    title: 'Last updated: August 2025\n',
    description:
      `These Terms & Conditions (“Terms”) govern participation in the Soopra.ai “AI Persona Creation Contest” (“Contest”). By entering, participants agree to these Terms, as well as Soopra.ai’s [General Terms of Service](${window.location.origin}/terms) and [Privacy Policy](${window.location.origin}/terms#privacy).\n`,
    listItems:
      [
        {title: 'Eligibility',
          listItems: [
            `Open to individuals who are **18 years or older** at the time of entry.`,
            `Open worldwide, except where prohibited or restricted by law.`,
            `One (1) entry per person.`,
            `Employees, contractors, affiliates, and immediate family members of Soopra.ai are **not eligible**.`,
          ],
        },
        {title: 'Contest Period',
          listItems: [
            `**Start Date:** Sep 01, 2025 at 12:00 AM PT`,
            `**End Date:** September 30, 2025 at 11:59 PM PT`,
            `The Contest runs for a continuous **30-day period**.`,
            `Entries received outside the Contest Period will not be considered.`,
          ],
        },
        {title: 'How to Enter',
          description: `To qualify as a valid entry, participants must:`,
          listItems: [
            `Create an AI Persona (“AI Twin” of yourself) on Soopra.ai with **profile completion** (photo, name, occupation, expertise tags, bio, and content uploads).`,
            // `Train their AI daily for **30 consecutive days** (journal entries, knowledge uploads, or Q&A training).`,
            `Gain at least **500 authentic followers** during the Contest Period.`,
            `Adhere to Soopra.ai’s **Community Guidelines** at all times.`,
          ],
        },
        {title: 'Scoring & Judging Criteria',
          description: `Winners will be determined by a combined scoring system:`,
          listItems: [
            `**Persona Completeness** – profile depth, quality of content, diversity of inputs.`,
            `**Training Consistency** – daily engagement, streak maintenance, improvement in responses.`,
            `**Engagement & Followers** – number of authentic followers, interaction quality, chat engagement.`,
            `**Discovery & Reputation**  – external shares, saves, reputation signals.`,
          ],
          footer: `Soopra.ai reserves the right to verify all data and adjust scores in cases of fraud, abuse, or error.`
        },
        {title: 'Anti-Gaming & Disqualification',
          listItems: [
            `Use of **fake accounts, bots, spam tactics, or artificial followers** will result in immediate disqualification.`,
            `Entries containing inappropriate, offensive, or harmful content will be removed.`,
            `Soopra.ai reserves the right to audit participants and request verification of followers and activity.`,
            `Decisions made by Soopra.ai regarding fraud, abuse, or eligibility are **final and binding**.`,
          ],
        },
        {title: 'Prizes',
          listItems: [
            `**1st Prize:** USD $1,000`,
            `**2nd Prize:** USD $600`,
            `**3rd Prize:** USD $400`,
            `Total prize pool: **USD $2,000**`,
            `Prizes will be paid via PayPal or bank transfer within **30 days** of winner confirmation.`,
            `Winners are responsible for any **applicable taxes, fees, or exchange costs**.`,
            `No transfer, substitution, or cash alternative is permitted, except at Soopra.ai’s discretion.`,
          ],
        },
        {title: 'Winner Notification & Verification',
          listItems: [
            `Winners will be announced on **October 3rd, 2025** via Soopra.ai’s website and official channels.`,
            `Winners will be notified by email and must respond within **7 days** to claim their prize.`,
            `Failure to respond in time may result in disqualification and prize reassignment.`,
            `Winners may be required to provide identification, proof of eligibility, and (if applicable) tax documents (e.g., W-9 or W-8BEN).`,
          ],
        },
        {title: 'Intellectual Property & Content Rights',
          listItems: [
            `Participants retain ownership of the original content used to train their AI persona.`,
            `By entering, participants grant Soopra.ai a **non-exclusive, royalty-free license** to showcase their AI persona, profile, and contest activity for promotional and marketing purposes.`,
          ],
        },
        {title: 'Privacy & Data',
          listItems: [
            `Personal data collected during the Contest will be processed in accordance with Soopra.ai’s [Privacy Policy](${window.location.origin}/terms#privacy).`,
            `Participation involves automatic metrics tracking (profile completion, followers, streaks, and engagement).`,
          ],
        },
        {title: 'General Conditions',
          listItems: [
            `Soopra.ai reserves the right to cancel, suspend, or modify the Contest if technical failures, fraud, or other causes compromise its integrity.`,
            `Soopra.ai’s decisions regarding all aspects of the Contest are **final and binding**.`,
            `Participation constitutes acceptance of these Terms.`,
          ],
        },
        {title: 'Limitation of Liability',
          description: `By participating, entrants release Soopra.ai and its affiliates from liability for:`,
          listItems: [
            `Losses, damages, or injuries related to participation or prize acceptance.`,
            `Technical errors, service interruptions, or unauthorized access affecting Contest outcomes.`,
          ],
        },
        {title: ' Governing Law',
          listItems: [
            `These Terms are governed by the laws of **California, USA**, without regard to conflict of law provisions.`,
            `Disputes will be resolved exclusively in the courts of **San Francisco County, CA**.`,
          ],
        },
      ]
  }
